import { render, staticRenderFns } from "./Process-5.vue?vue&type=template&id=138a4d92&scoped=true&"
import script from "./Process-5.vue?vue&type=script&lang=js&"
export * from "./Process-5.vue?vue&type=script&lang=js&"
import style0 from "./Process-5.vue?vue&type=style&index=0&id=138a4d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a4d92",
  null
  
)

export default component.exports